import { render, staticRenderFns } from "./trip_filter.vue?vue&type=template&id=206c664c&scoped=true&"
import script from "./trip_filter.vue?vue&type=script&lang=js&"
export * from "./trip_filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206c664c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('206c664c')) {
      api.createRecord('206c664c', component.options)
    } else {
      api.reload('206c664c', component.options)
    }
    module.hot.accept("./trip_filter.vue?vue&type=template&id=206c664c&scoped=true&", function () {
      api.rerender('206c664c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/calendar/trip/trip_filter.vue"
export default component.exports